import { WIKI_CATEGORIES } from 'mk/autogenerated/wikiCategories';

export const wiki = '/wiki/';
export const wikiArticle = `/:categorySlug(${WIKI_CATEGORIES.map((wc) => wc.slug).join('|')})/:articleSlug/`;
export const wikiArticleEdit = '/wiki/article/edit/:articleId/';
export const wikiArticleCreate = '/wiki/article/new/';
export const wikiAddExperience = '/wiki/article/:categorySlug/:articleSlug/add-experience/';
